<div>
  <p>Adicionar produtos ao comparador</p>
  <mat-form-field class="chip-list">
    <mat-chip-grid #chipGrid>
      @for (product of products; track product) {
        <mat-chip-row
          (removed)="remove(product)"
          [editable]="true"
          (edited)="edit(product, $event)">
          {{product.reference}}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
      @if (true) {
        <input placeholder="Por referência..."
          [matChipInputFor]="chipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)"
          [formControl]="myControl"
          [matAutocomplete]="auto"
          #input
          />
      }
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
        @for (option of sugestedOptions | async | slice: 0 : 100; track option) {
          <mat-option [value]="option">
            {{option}}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-chip-grid>
  </mat-form-field>
</div>